import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { CloseIcon } from '@svgComponents';
import { t } from 'ttag';
import { IconButton } from '@coolremote/shared';
import addEditScheduleStyles from '../addEditSchedule.style';

const useStyles = makeStyles(addEditScheduleStyles);

interface ScheduleWrapperProps {
    onXClick: () => void;
    isEditMode: boolean;
    children?: React.ReactNode;
    isDesktop?: boolean;
}

const ScheduleWrapper: React.FC<ScheduleWrapperProps> = ({ onXClick, isEditMode, children, isDesktop }) => {
    const classes = useStyles();

    const title = isEditMode ? t`Edit Schedule` : t`Add Schedule`;

    return (
        <div className={classes.rootContainer} style={ isDesktop ? {} : { padding: 0 }}>
            <div className={classes.content} style={ isDesktop ? {} : { borderRadius: 0 }}>
                <div className={classes.headerStyle}>
                    <Typography style={{ color: '#fff', fontSize: 26 }}>{title}</Typography>
                    <IconButton
                        onClick={onXClick}
                        className={classes.bigIconBtnStyle}
                    >
                        <CloseIcon style={{ transform: 'scale(1.3)' }} />
                    </IconButton>
                </div>
                <div className={classes.scheduleInfoContainer}>
                    <div className={classes.mainContent}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScheduleWrapper